module.exports = __webpack_public_path__ + "img/strava_step_3_2.57996524.png";